export const progressStepNames = Object({
    stepName1: 'step1',
    stepName2: 'step2',
    stepName3: 'step3',
    stepName4: 'step4',
    stepName5: 'step5',
});
